import React from 'react';
import DashboardLayout from './DashboardLayout';
import InteriorHeader from '../components/interior/InteriorHeader';
import InteriorRightPanel from '../components/interior/InteriorRightPanel';
import InteriorCanvas from '../components/interior/InteriorCanvas';

const InteriorLayout: React.FC = () => {
    return (
        <DashboardLayout>
            <div className="flex h-screen w-full bg-stone-950 text-zinc-100 overflow-hidden font-sans">

                {/* Center Content */}
                <div className="flex-1 flex flex-col min-w-0 bg-stone-950 relative z-0">
                    <InteriorHeader />
                    <div className="flex-1 relative flex flex-col min-h-0 overflow-hidden">
                        <InteriorCanvas />
                    </div>
                </div>

                {/* Right Panel — Interior-specific controls */}
                <InteriorRightPanel />

            </div>
        </DashboardLayout>
    );
};

export default InteriorLayout;
